<div class="filters" #filtersRef>
  <mode-labeled-menu
    class="display-container"
    label="Content type"
    [multiselectEnabled]="true"
    [keepMenuOpenAfterSelect]="true"
    [selected]="selectedContentTypeItems"
    [highlightedError]="!selectedContentTypeItems.length && (_filterInit$ |async) === 'initialized'"
    menuClass="autocomplete-menu"
    [menuItems]="contentTypeItems"
    (menuChange)="onChangeContentType($event)"
    (menuOpened)="onMenuOpen()"
    (menuClosed)="onMenuClose()"
  ></mode-labeled-menu>
  <div class="matchon-filter">
    <mode-labeled-menu
      class="display-container"
      label="Match on"
      [multiselectEnabled]="true"
      [keepMenuOpenAfterSelect]="true"
      [selected]="selectedMatchOnItems"
      [highlightedError]="!selectedMatchOnItems.length && (_filterInit$ |async) === 'initialized'"
      menuClass="autocomplete-menu"
      [menuItems]="matchOnItems"
      (menuChange)="onChangeMatchOn($event)"
      (menuOpened)="onMenuOpen()"
      (menuClosed)="onMenuClose()"
    ></mode-labeled-menu>
  </div>
  <div class="created-by-filter checkbox-icon">
    <input class="created-by-filter-control" id="global-search-created-by-filter" type="checkbox" (change)="onChangeCreatedByMe($event)"/>
    <label class="form-control-label icon-editor-checkbox-light-unchecked" for="global-search-created-by-filter">Created&nbsp;by&nbsp;me</label>
  </div>
</div>
